import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { google_auth_client_id } from "./constants";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={google_auth_client_id}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// Register the service worker
// This will enable the PWA features and caching
// Ensure that the service worker is registered with the correct version
serviceWorkerRegistration.register({
  onUpdate: registration => {
    if (registration && registration.waiting) {
      // force activate the new SW and reload
      registration.waiting.postMessage({ type: "SKIP_WAITING" });

      // reload the page when the new service worker takes control
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });
    }
  },
  onSuccess: registration => {
    registration.update();
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
